import React from 'react';
import useGlobalStoreContext from '../../../Contexts/GlobalContext/Contexts/GlobalStoreContext/useGlobalStoreContext';
import useContentMaps from '../../Hooks/useSession/useContentMaps';
import { LatestDetection } from '../Contexts/SessionDetectionContextProvider/useSessionDetectionContext';
import useSessionStoreContext from '../Contexts/SessionStoreContextProvider/useSessionStoreContext';

export default function useUpdateDetectionHistory() {
  const { latestDetection: [latestDetection], detectionHistory: [, setDetectionHistory], sessionId: [sessionId] } = useSessionStoreContext();
  const { projectId: [projectId] } = useGlobalStoreContext();
  const { cardTitleMap, commandTitleMap, isIntentionMap } = useContentMaps(projectId);

  const sessionIdRef = React.useRef(sessionId);

  React.useEffect(() => {
    if (sessionIdRef.current !== sessionId) {
      setDetectionHistory([]);
    }
    sessionIdRef.current = sessionId;
  }, [sessionId]);

  React.useEffect(() => {
    if (latestDetection) {
      setDetectionHistory((prev) => {
        const newDetection: LatestDetection & { cardTitle?: string, commandTitle?: string, isIntention?: boolean } = {
          ...latestDetection,
        };
        if (latestDetection.cardId && cardTitleMap.has(latestDetection.cardId)) {
          newDetection.cardTitle = cardTitleMap.get(latestDetection.cardId);
        }
        if (commandTitleMap.has(latestDetection.commandId)) {
          newDetection.commandTitle = commandTitleMap.get(latestDetection.commandId);
          newDetection.isIntention = isIntentionMap.get(latestDetection.commandId) ?? undefined;
        } else {
          console.error('Command title not found for commandId ', latestDetection.commandId, 'after detection');
        }
        return [...prev, newDetection];
      });
    }
  }, [latestDetection, commandTitleMap, cardTitleMap, isIntentionMap]);
}
